<template>
  <div style="text-align:center;" id="main">
    <button class="fullBtn" @click="redirect()">
      <inline-svg
        class="googleIcon"
        :src="require('../../assets/svg/googleicon.svg').default"
      ></inline-svg>
      {{ $t("user.loginButton.button") }}
    </button>
  </div>
</template>

<script>
import { authService } from "../../services/authService";


export default {
  name: "GoogleButton",
  methods: {
    redirect() {
      window.location.href = `${authService.googleLogin}`
    }
  }
}
</script>


// WEBPACK FOOTER //
// googleButton.vue?6620371e